import React from "react";
import { generateCoord, getColor } from "../Targets/Generators";
import Target from "../Targets/Target";

/**
 * Creates an iron sights target
 * @param settingsContext is the settings context
 * @param id is the key of the target
 * @param leftBound is the left bound of the target
 * @param rightBound is the right bound of the target
 * @param setScore is the score function of the round
 * @param setMisses is the miss function of the round
 * @param setClicks
 * @param setDistSum
 * @param targetAcc is the acceleration of the target
 * @param targetVel is the velocity of the target
 * @returns an iron sights target
 */
const createIronSightsTarget = (
  settingsContext: any,
  id: number,
  leftBound: number,
  rightBound: number,
  setScore: React.Dispatch<React.SetStateAction<number>>,
  setMisses: React.Dispatch<React.SetStateAction<number>>,
  setClicks: React.Dispatch<React.SetStateAction<number>>,
  setDistSum: React.Dispatch<React.SetStateAction<number>>,
  targetAcc: number,
  targetVel: number,
  showProjectiles: boolean
) => {
  return (
    <Target
      static={false}
      key={id + 1}
      position={generateCoord(leftBound, rightBound, 1, 1, -30, -30)}
      size={[1.5, 1.5, 1.5]}
      color={getColor(settingsContext.targetColors)}
      projectileColor={settingsContext.projectileColor}
      scoreUpdater={() => setScore((prev) => prev + 1)}
      missesUpdater={() => setMisses((prev) => prev + 1)}
      clicksUpdater={(clicks: number) => setClicks((prev) => prev + clicks)}
      distancesUpdater={(dist: number) => setDistSum((prev) => prev + dist)}
      targetUpwardVel={0.17}
      targetAcc={targetAcc}
      targetForwardVel={targetVel}
      duration={0}
      showProjectiles={showProjectiles}
    />
  );
};

export default createIronSightsTarget;
